import { left } from "@popperjs/core";
import Swiper from "swiper";
import { Navigation, Thumbs } from "swiper/modules";

jQuery(($) => {
	if ($(".slider-both").length > 0) {
		//scroll
		/*var $heading = $(".slider-both .heading");
		var position = $heading.offset().left;

		console.log($heading);
		console.log(position);

		$(window).on("load resize", function () {
			if ($heading.length > 0) {
				$(".shifted .swiper").css({
					//left: position + "px",
					transform: "translate3d(" + position + "px, 0px, 0px)",
				});
			}
		});

		if ($(window).width() < 768) {
			$(window).on("load resize", function () {
				var position = $(".shifted .heading").offset();
				$(".columns.shifted .swiper-wrapper").css(
					"left",
					position.left + 30 + "px"
				);
			});
		}

		//var isFirstSlideChange = true;
		const swiperColumns = new Swiper(".slider-mobile", {
			loop: false,
			spaceBetween: 0,
			slidesPerView: "auto",
		}); */
	}

	if ($(".slider-columns").length > 0) {
		const swiperColumns = new Swiper(".slider-columns", {
			init: false,
			loop: false,
			spaceBetween: 0,
			slidesPerView: "auto",
		});

		if ($(window).width() < 1024) {
			initSlick();
		}

		if ($(".slider-both").length > 0) {
			initSlick();
		}

		$(window).on("resize scroll", function () {
			if ($(window).width() < 1024) {
				initSlick();
			} else {
				destroySlick();
			}
		});

		function initSlick() {
			swiperColumns.init();
			//	console.log("init");
		}
		function destroySlick() {
			swiperColumns.destroy();
			//	console.log("destroy");
		}
	}
	if ($(".custom-columns-slide").length > 0) {
		$(".custom-columns-slide").on("click", function () {
			var url = $(this).data("url");
			window.location.href = url;
		});
	}
});
